import {Component, OnInit} from '@angular/core';
import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {MetaTitle} from '../../../../decorator/meta-title';
import {Report} from '../../../../models/statistic/report';
import {StatisticService} from '../../../../services/statistic/statistic.service';
import {ActivatedRoute} from '@angular/router';
import {LoaderService} from '../../../../services/loader/loader.service';
import {PercentPipe} from '../../../../pipes/percent/percent.pipe';
import {MoneyPipe} from '../../../../pipes/money/money.pipe';

@Component({
  selector: 'app-basic-report',
  imports: [
    NgIf,
    NgForOf,
    DatePipe,
    PercentPipe,
    MoneyPipe
  ],
  templateUrl: './basic-report.component.html',
  styleUrl: './basic-report.component.scss'
})
@MetaTitle('Report')
export class BasicReportComponent implements OnInit {

  reportType: string = 'daily';
  statistics: Report[] = [];

  constructor(
    protected loader: LoaderService,
    private route: ActivatedRoute,
    private statisticService: StatisticService,
  ) {
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.reportType = params.get('report') ?? 'daily';
      if (!StatisticService.REPORTS.includes(this.reportType)) {
        this.reportType = 'daily';
      }

      this.statistics = [];

      this.statisticService.$filters.subscribe((filters: any) => {
        this.loader.startLoading();
        this.statisticService.fetchBasicReport(this.reportType, filters).subscribe((statistics: Report[]) => {
          this.statistics = statistics;
          this.loader.stopLoading();
        });
      });
    });
  }

  isDaily(): boolean {
    return this.reportType === 'daily';
  }
}
